module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "vue-contextmenu-listWrapper",
    class: 'vue-contextmenuName-' + _vm.contextMenuData.menuName
  }, _vm._l((_vm.contextMenuData.menulists), function(item) {
    return _c('li', {
      key: item.btnName,
      staticClass: "context-menu-list"
    }, [_c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.fnHandler(item)
        }
      }
    }, [_c('i', {
      class: item.icoName
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.btnName))])])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1931f86e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/VueContextMenu.vue
// module id = 6
// module chunks = 0